<template>
  <div class="row d-flex justify-content-center">
    <div class="col-9">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template v-else-if="info.type === 'contacts'">
              <td-contacts-info
                :contactsInfo="info.value"
                :infoData="infoData"
              />
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';
import TdContactsInfo from './TdContactsInfo.vue';

export default {
  name: 'step-confirm',
  components: {
    [TdInfoTag.name]: TdInfoTag,
    [TdContactsInfo.name]: TdContactsInfo,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
  },
  data() {
    return {
      renderComponent: true,
    };
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.nit'),
          value: this.infoData.nit,
        },
        {
          label: i18n.t('common_words.name'),
          value: this.infoData.name,
        },
        {
          label: i18n.t('common_words.phone'),
          value: this.infoData.phone,
        },
        {
          label: i18n.t('common_words.email'),
          value: this.infoData.email,
        },
        {
          label: i18n.t('common_words.comercial_name'),
          value: this.infoData.tradename,
        },
        {
          label: i18n.t('common_words.website'),
          value: this.infoData.web_site,
        },
        {
          label: i18n.t('common_words.economic_activity'),
          value: this.infoData.comercial_activity,
        },
        {
          label: i18n.t('common_words.address'),
          value: `${
            this.infoData.zip_code ? `${this.infoData.zip_code} - ` : ' - '
          } ${this.infoData.city}, ${this.infoData.state} - ${
            this.infoData.country
          }; ${this.infoData.address}`,
        },
        {
          label: i18n.t('common_words.contacts'),
          value: this.infoData.contact_names,
          type: 'contacts',
          fieldTag: 'option',
        },
      ];
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showInfoTag(info) {
      return (
        (typeof info.visibility === 'undefined' || Boolean(info.visibility)) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'contacts'
      );
    },
  },
};
</script>
